// Badge counts (architecture §21.5, WP0): from /api/bootstrap and `counts` SSE events. Drives nav badges and the app
// icon badge (navigator.setAppBadge) while the app is open.
import { create } from 'zustand';
import type { Counts } from '@hq/shared';

export interface BadgeStore {
  counts: Counts;
  setCounts(c: Counts): void;
}

const ZERO: Counts = { approvals: 0, unreadThreads: 0, unreadReports: 0, notifications: 0 };

/** The icon badge shows what needs Chris: open approvals plus unread chats. */
export const appBadgeCount = (c: Counts) => c.approvals + c.unreadThreads;

function setAppBadge(n: number): void {
  const nav = typeof navigator === 'undefined' ? undefined : (navigator as Navigator & {
    setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void>;
  });
  if (!nav?.setAppBadge) return;
  (n > 0 ? nav.setAppBadge(n) : nav.clearAppBadge?.() ?? Promise.resolve()).catch(() => undefined);
}

export const useBadgeStore = create<BadgeStore>((set) => ({
  counts: ZERO,
  setCounts(c) {
    set({ counts: c });
    setAppBadge(appBadgeCount(c));
  },
}));
